<input
  #startInput="ngModel"
  type="text"
  class="border-0 p-0 focus-none"
  siDateInput
  [ngModel]="value()?.start ?? null"
  [siDatepickerConfig]="siDatepickerConfig()"
  [placeholder]="startDatePlaceholder() | translate"
  [attr.aria-label]="startDatePlaceholder() | translate"
  [errormessageId]="errormessageId()"
  [disabled]="disabled()"
  [readonly]="readonly()"
  (ngModelChange)="onInputChanged({ start: $event, end: value()?.end })"
  (validationChange)="onValidatorChange()"
/>
<span class="mx-3">-</span>
<input
  #endInput="ngModel"
  type="text"
  class="border-0 p-0 focus-none text-end"
  siDateInput
  [ngModel]="value()?.end ?? null"
  [siDatepickerConfig]="siDatepickerConfig()"
  [placeholder]="endDatePlaceholder() | translate"
  [attr.aria-label]="endDatePlaceholder() | translate"
  [errormessageId]="errormessageId()"
  [disabled]="disabled()"
  [readonly]="readonly()"
  (ngModelChange)="onInputChanged({ start: value()?.start, end: $event })"
  (validationChange)="onValidatorChange()"
/>
<div class="form-control-actions">
  <button
    #button
    type="button"
    class="btn btn-icon btn-tertiary btn-sm"
    [attr.aria-label]="ariaLabelCalendarButton() | translate"
    [disabled]="disabled() || readonly()"
    (click)="show()"
  >
    <si-icon [icon]="icons.elementCalendar" />
  </button>
</div>
